import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-close';
export const CloseIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={`0 0 18 18`}
            data-testid={TESTID}
        >
            <path
                className={fillStyles}
                d="M10.4139607,9.00025 L17.7067581,1.70725 C18.0977473,1.31625 18.0977473,0.68425 17.7067581,0.29325 C17.315769,-0.09775 16.6837866,-0.09775 16.2927974,0.29325 L9,7.58625 L1.70720258,0.29325 C1.31621344,-0.09775 0.684230994,-0.09775 0.293241854,0.29325 C-0.0977472848,0.68425 -0.0977472848,1.31625 0.293241854,1.70725 L7.58603928,9.00025 L0.293241854,16.29325 C-0.0977472848,16.68425 -0.0977472848,17.31625 0.293241854,17.70725 C0.488236438,17.90225 0.744229327,18.00025 1.00022222,18.00025 C1.25621511,18.00025 1.51220799,17.90225 1.70720258,17.70725 L9,10.41425 L16.2927974,17.70725 C16.487792,17.90225 16.7437849,18.00025 16.9997778,18.00025 C17.2557707,18.00025 17.5117636,17.90225 17.7067581,17.70725 C18.0977473,17.31625 18.0977473,16.68425 17.7067581,16.29325 L10.4139607,9.00025 Z"
            />
        </svg>
    );
};
CloseIcon.TEST_ID = TESTID;
